enum EventCategoryEnum {
  visitContextRaw = 'visitContextRaw',
  simpleUi = 'simpleUi'
}

enum EventCategoryGunEnum {
  visitContextRaw = 'com.hp.cdm.domain.telemetry.type.eventDetail.category.visitContextRaw.version.1',
  simpleUi = 'com.hp.cdm.domain.telemetry.type.eventDetail.category.simpleUi.version.1'
}


enum EventDataActivityEnum {
  allV01 = "All-v01",
}

enum EventSchemaVersionEnum {
  simpleUi = "1.4.0",
  visitContextRaw = "1.0.0",
  eventingEvent = "1.4.0",
}

export {
  EventCategoryEnum,
  EventCategoryGunEnum,
  EventDataActivityEnum,
  EventSchemaVersionEnum,
};
